import { LitElement, html, svg } from 'lit';

export class IconAutomatic32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Girkasse automat</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M24.667 19v-6l4 6v-6M28.667 27a4 4 0 0 0-4-4v8a4 4 0 0 0 4-4ZM24.667 5h2a2 2 0 0 0 0-4h-2v8M6.667 9v6a2 2 0 0 0 2 2h2a2 2 0 0 1 2 2v6a2 2 0 0 0 2 2h4M6.667 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"></path></svg>`; }
}
if (!customElements.get('f-icon-automatic32', IconAutomatic32)) {
  customElements.define('f-icon-automatic32', IconAutomatic32);
}